import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

// Apis
import useFetch from "utils/hooks/useFetch";
// import { API_BASE_URL } from "utils/constants/api";
import {
  CREATE_SUBMISSION,
  DOWNLOAD_REGISTRATION_FORM,
  UPLOAD_PAYMENT_EVIDENCE,
} from "api";

// Images & Icons
import banner from "assets/images/esg_awards_home_banner.png";

// Components
import HostedBy from "./home/HostedBy";
import Categories from "./home/Categories";
import JudgingProcess from "./home/JudgingProcess";
import Judges from "./home/Judges";
import FAQ from "./home/FAQ";
import About from "./home/About";
import Contact from "./home/Contact";
import RegisterModal from "./home/RegisterModal";
// import extractErrorMessageFromHTML from "helpers/extractErrorMessageFromHTML";
import ScoringCriteria from "./home/ScoringCriteria";
import AwardsFlowchart from "./home/AwardsFlowchart";

function Home() {
  const { fetch: createSubmission } = useFetch(CREATE_SUBMISSION);
  const { fetch: requestDownloadRFI } = useFetch(DOWNLOAD_REGISTRATION_FORM);
  const { fetch: uploadPaymentEvidence } = useFetch(UPLOAD_PAYMENT_EVIDENCE);

  const { t } = useTranslation();

  const [userForm, setUserForm] = useState({
    companyName: "",
    contactPersonName: "",
    emailAddress: "",
    phoneCode: "",
    phoneNumber: "",
    userDocument1: "",
    userDocument2: "",
    userDocumentEvidence: "",
    registrationNumber: "",
    paymentEvidenceDocument: "",
    validCompanyName: true,
    validContactPersonName: true,
    validEmailAddress: true,
    validPhoneCode: true,
    validPhoneNumber: true,
    validEmailFormat: true,
    validUserDocument1: true,
    validUserDocument1FileSize: true,
    validUserDocument1FileType: true,
    validUserDocument1FileName: true,
    validUserDocument2: true,
    validUserDocument2FileSize: true,
    validUserDocument2FileType: true,
    validUserDocument2FileName: true,
    validUserDocumentEvidence: true,
    validUserDocumentEvidenceFileSize: true,
    validUserDocumentEvidenceFileType: true,
    validUserDocumentEvidenceFileName: true,
    validRegistrationNumber: true,
    validPaymentEvidenceDocument: true,
    validPaymentEvidenceDocumentFileSize: true,
    validPaymentEvidenceDocumentFileType: true,
  });

  const [loading, setLoading] = useState(false);

  const videoRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState("100vh");
  const [showOverlay, setShowOverlay] = useState(true);

  const handlePlayVideo = () => {
    setShowOverlay(false);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      const navbar = document.querySelector(".sticky.top-0");
      const navHeight = navbar ? navbar.offsetHeight : 0;
      setVideoHeight(`calc(100vh - ${navHeight}px)`);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const [registerModal, setRegisterModal] = useState({
    isOpenRegisterModal: false,
    isOpenUserForm: false,
    isOpenUploadForm: false,
    isOpenDownloadForm: false,
    isOpenPaymentEvidenceForm: false,
  });

  const handleOnClickDownloadForm = () => {
    // hit api server to send email for request download RFI
    setLoading(true);
    const { contactPersonName, emailAddress, companyName } = userForm;

    const data = {
      registrant_email: emailAddress,
      registrant_name: contactPersonName,
      registrant_company_name: companyName,
    };

    requestDownloadRFI({ data })
      .then(() => {
        setUserFormEmpty();
        handleOnCloseRegisterModal();
        Swal.fire({
          title: "Congratulations",
          text: "Email sent!",
          icon: "success",
          position: "top-right",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err?.data?.message || err?.data?.name,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .finally(() => {
        setLoading(false);
      });

    // window.open(`${API_BASE_URL}${DOWNLOAD_REGISTRATION_FORM.url}`, "_blank");
    // handleOnCloseRegisterModal();
    // Swal.fire({
    //   title: "Please wait",
    //   text: "Downloading your registration form...",
    //   icon: "info",
    //   position: "top-right",
    //   showConfirmButton: false,
    //   timer: 3000,
    // }).finally(() => {});
  };

  const handleOpenUploadForm = ({
    firstForm,
    secondForm,
    downloadForm,
    paymentEvidenceForm,
  }) => {
    const {
      companyName,
      contactPersonName,
      emailAddress,
      phoneCode,
      phoneNumber,
      userDocument,
      registrationNumber,
      paymentEvidenceDocument,
    } = userForm;

    if (firstForm) {
      let isValidCompanyName = false;
      let isValidContactPersonName = false;
      let isValidEmailAddress = false;
      let isEmailFormat = true;
      let isValidPhoneCode = false;
      let isValidPhoneNumber = false;

      if (companyName) {
        isValidCompanyName = true;
      }
      if (contactPersonName) {
        isValidContactPersonName = true;
      }
      if (emailAddress) {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
          isValidEmailAddress = true;
          isEmailFormat = true;
        } else {
          isEmailFormat = false;
        }
      }
      if (phoneCode) {
        isValidPhoneCode = true;
      }
      if (phoneNumber) {
        isValidPhoneNumber = true;
      }

      setUserForm((prev) => ({
        ...prev,
        validCompanyName: isValidCompanyName,
        validContactPersonName: isValidContactPersonName,
        validEmailAddress: isValidEmailAddress,
        validPhoneCode: isValidPhoneCode,
        validPhoneNumber: isValidPhoneNumber,
        validEmailFormat: isEmailFormat,
      }));

      if (
        isValidCompanyName &&
        isValidContactPersonName &&
        isValidEmailAddress &&
        isValidPhoneCode &&
        isValidPhoneNumber &&
        isEmailFormat
      ) {
        // continue to second form
        setRegisterModal({
          ...registerModal,
          isOpenUserForm: false,
          isOpenUploadForm: true,
        });
      }
    }

    if (secondForm) {
      let isValidUserDocument = false;

      if (userDocument) {
        isValidUserDocument = true;
      }

      if (isValidUserDocument) {
        handleUploadUserForm();
      } else {
        // munculkan validasi user document required
        setUserForm((prev) => ({
          ...prev,
          validUserDocument: isValidUserDocument,
        }));
      }
    }

    if (downloadForm) {
      let isValidCompanyName = false;
      let isValidContactPersonName = false;
      let isValidEmailAddress = false;
      let isEmailFormat = true;

      if (companyName) {
        isValidCompanyName = true;
      }
      if (contactPersonName) {
        isValidContactPersonName = true;
      }
      if (emailAddress) {
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
          isValidEmailAddress = true;
          isEmailFormat = true;
        } else {
          isEmailFormat = false;
        }
      }

      setUserForm((prev) => ({
        ...prev,
        validCompanyName: isValidCompanyName,
        validContactPersonName: isValidContactPersonName,
        validEmailAddress: isValidEmailAddress,
      }));

      if (
        isValidCompanyName &&
        isValidContactPersonName &&
        isValidEmailAddress &&
        isEmailFormat
      ) {
        // continue to download RFI
        handleOnClickDownloadForm();
      }
    }

    if (paymentEvidenceForm) {
      let isValidRegistrationNumber = false;
      let isValidPaymentEvidenceDocument = false;

      if (registrationNumber) {
        isValidRegistrationNumber = true;
      }
      if (paymentEvidenceDocument) {
        isValidPaymentEvidenceDocument = true;
      }

      setUserForm((prev) => ({
        ...prev,
        validRegistrationNumber: isValidRegistrationNumber,
        validPaymentEvidenceDocument: isValidPaymentEvidenceDocument,
      }));

      if (isValidRegistrationNumber && isValidPaymentEvidenceDocument) {
        // continue to upload payment evidence
        handleOnClickUploadPaymentEvidence();
      }
    }
  };

  const setUserFormEmpty = () => {
    setUserForm((prev) => ({
      ...prev,
      companyName: "",
      contactPersonName: "",
      emailAddress: "",
      phoneCode: "",
      phoneNumber: "",
      userDocument1: "",
      userDocument2: "",
      userDocumentEvidence: "",
      registrationNumber: "",
      paymentEvidenceDocument: "",
    }));
  };

  const handleUploadUserForm = () => {
    // hit api server to save user data
    setLoading(true);
    const data = new FormData();

    data.append("contact_person_name", userForm.contactPersonName);
    data.append("user_email", userForm.emailAddress);
    data.append("company_names", userForm.companyName);
    data.append("phone_code", userForm.phoneCode);
    data.append("phone_number", userForm.phoneNumber);
    data.append("user_document", userForm.userDocument1);
    if (userForm.userDocument2) {
      data.append("user_document", userForm.userDocument2);
    }
    if (userForm.userDocumentEvidence) {
      data.append("user_document_evidence", userForm.userDocumentEvidence);
    }

    createSubmission({ data })
      .then(() => {
        setUserFormEmpty();
        handleOnCloseRegisterModal();
        Swal.fire({
          title: "Congratulations",
          text: "Registration submitted!",
          icon: "success",
          position: "top-right",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err?.data?.message || err?.data?.name,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOnCloseRegisterModal = () => {
    setRegisterModal({
      ...registerModal,
      isOpenRegisterModal: false,
      isOpenUserForm: false,
      isOpenUploadForm: false,
      isOpenDownloadForm: false,
      isOpenPaymentEvidenceForm: false,
    });
  };

  const getValidationValueForEachUploadedFile = (
    fileSize,
    fileType,
    fileName,
    maxFileSize,
    allowedEvidenceFileType,
    allowedFileType,
    allowedPaymentEvidenceFileType,
    key,
  ) => {
    let fileObjValue = {};

    let isValid = false;
    const validFileSize = fileSize < maxFileSize;
    const validFileType =
      key === "userDocumentEvidence"
        ? allowedEvidenceFileType.includes(fileType)
        : key === "paymentEvidenceDocument"
          ? allowedPaymentEvidenceFileType.includes(fileType)
          : allowedFileType.includes(fileType);
    const validFileName = !fileName ? false : fileName.includes("-") === false;

    switch (key) {
      case "userDocument1":
        fileObjValue = {
          validUserDocument1FileSize: validFileSize,
          validUserDocument1FileType: validFileType,
          validUserDocument1FileName: validFileName,
          validUserDocument1: validFileSize && validFileType && validFileName,
        };
        isValid = validFileSize && validFileType && validFileName;
        break;
      case "userDocument2":
        fileObjValue = {
          validUserDocument2FileSize: validFileSize,
          validUserDocument2FileType: validFileType,
          validUserDocument2FileName: validFileName,
          validUserDocument2: validFileSize && validFileType && validFileName,
        };
        isValid = validFileSize && validFileType && validFileName;
        break;
      case "userDocumentEvidence":
        fileObjValue = {
          validUserDocumentEvidenceFileSize: validFileSize,
          validUserDocumentEvidenceFileType: validFileType,
          validUserDocumentEvidenceFileName: validFileName,
          validUserDocumentEvidence:
            validFileSize && validFileType && validFileName,
        };
        isValid = validFileSize && validFileType && validFileName;
        break;
      case "paymentEvidenceDocument":
        fileObjValue = {
          validUserDocumentEvidenceFileSize: validFileSize,
          validUserDocumentEvidenceFileType: validFileType,
          validUserDocumentEvidence: validFileSize && validFileType,
        };
        isValid = validFileSize && validFileType;
        break;
      default:
    }

    return { fileObjValue, isValid };
  };

  const validateOnChangeImage = (key, file) => {
    if (!file) return;

    const fileSize = file.size;
    const fileType = file.type;
    const fileName = file.name;
    const maxFileSize = 10 * 1024 * 1024; // 10 Mb

    const allowedEvidenceFileType = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/pdf", // .pdf
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    const allowedFileType = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];
    const allowedPaymentEvidenceFileType = [
      "image/jpeg",
      "image/png",
      "image/jpg",
    ];

    const { fileObjValue, isValid } = getValidationValueForEachUploadedFile(
      fileSize,
      fileType,
      fileName,
      maxFileSize,
      allowedEvidenceFileType,
      allowedFileType,
      allowedPaymentEvidenceFileType,
      key,
    );

    setUserForm((prev) => ({
      ...prev,
      ...fileObjValue,
    }));

    return isValid ? file : "";
  };

  const handleInputChange = (key, value, isFile) => {
    let finalValue = value;

    if (isFile && value) {
      // for input document
      const file = value[0] || userForm[`${key}`];

      finalValue = validateOnChangeImage(key, file);
    }

    let objToSave = {
      [key]: finalValue,
    };

    if (key === "emailAddress") {
      // reset is valid email format into valid after value changes
      objToSave.validEmailFormat = true;
    }

    setUserForm((prev) => ({
      ...prev,
      ...objToSave,
    }));
  };

  const handleOnClickUploadPaymentEvidence = () => {
    // hit api server to upload submission payment evidence
    setLoading(true);
    const data = new FormData();

    data.append("registration_number", userForm.registrationNumber);
    data.append("payment_evidence", userForm.paymentEvidenceDocument);

    uploadPaymentEvidence({ data })
      .then(() => {
        setUserFormEmpty();
        handleOnCloseRegisterModal();
        Swal.fire({
          title: "Success",
          text: "Payment evidence uploaded!",
          icon: "success",
          position: "top-right",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err?.data?.message || err?.data?.name,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <section className="block">
        <div className="relative">
          <img
            src={banner}
            alt="main"
            className="w-full object-cover object-center h-[40vh] sm:h-[53.5vh] max-h-[90vh]"
          />
          <div className="absolute top-0 bottom-0 left-0 right-0 text-white">
            <div className="flex flex-col items-center justify-center h-full gap-4 text-center app-main-container sm:gap-4 md:gap-8 lg:gap-8 sm:items-start sm:text-left">
              <p className="max-w-[240px] text-xl font-semibold sm:max-w-md sm:text-2xl md:text-3xl lg:text-4xl sm:font-bold app-animation-translate-start">
                <div>{t("mainBannerTitle1")}</div>
                <div>{t("mainBannerTitle2")}</div>
                <div>{t("mainBannerTitle3")}</div>
              </p>

              <p className="max-w-[260px] text-xs sm:max-w-xl sm:text-sm md:text-md lg:text-lg app-animation-translate-start">
                {t("mainBannerText")}
              </p>

              <button
                className="px-2 py-1 text-sm sm:px-4 sm:text-sm md:text-md lg:text-lg font-bold text-white rounded-md bg-[#8DC63F] hover:bg-lime-600"
                onClick={() =>
                  setRegisterModal({
                    ...registerModal,
                    isOpenRegisterModal: true,
                  })
                }
              >
                <p>{t("registerNow")}</p>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="relative block w-full bg-black">
        <video
          ref={videoRef}
          src="https://storage.googleapis.com/testing_storage_cloudxier/Draft%205%20short.mp4"
          className="w-full object-contain sm:object-cover"
          style={{ height: videoHeight }}
          loop
          playsInline
          controls
        />
        {showOverlay && (
          <div
            onClick={handlePlayVideo}
            className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer bg-black/40 transition-opacity duration-300 hover:bg-black/50"
          >
            <button
              type="button"
              aria-label="Play video"
              className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 mb-4 sm:mb-6 transition-transform duration-300 bg-white rounded-full shadow-2xl hover:scale-110"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-10 h-10 sm:w-12 sm:h-12 text-black ml-1"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </button>
            <p className="text-xl font-bold tracking-wide text-white sm:text-2xl md:text-3xl drop-shadow-lg">
              Watch our video
            </p>
          </div>
        )}
      </section>

      <About />

      <section className="bg-[#f5f5f5]">
        <HostedBy />
      </section>

      <Categories />

      <ScoringCriteria />

      <JudgingProcess />

      <section className="bg-[#f5f5f5]">
        <Judges />
      </section>

      <section className="pt-10 pb-10">
        <AwardsFlowchart />
      </section>

      <section className="bg-[#f5f5f5]">
        <FAQ />
      </section>

      <Contact />

      <RegisterModal
        registerModal={registerModal}
        onClose={() => handleOnCloseRegisterModal()}
        handleOpenUserForm={() => {
          setRegisterModal({
            ...registerModal,
            isOpenUserForm: true,
          });
        }}
        handleOpenDownloadForm={() => {
          setRegisterModal({
            ...registerModal,
            isOpenDownloadForm: true,
          });
        }}
        handleOpenPaymentEvidenceForm={() => {
          setRegisterModal({
            ...registerModal,
            isOpenPaymentEvidenceForm: true,
          });
        }}
        onClickDownloadForm={handleOnClickDownloadForm}
        handleOpenUploadForm={handleOpenUploadForm}
        handleSubmitBtn={handleUploadUserForm}
        handleInputChange={handleInputChange}
        userForm={userForm}
        loading={loading}
      />
    </div>
  );
}

export default Home;